"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenuItem = exports.SubMenu = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const Animation_1 = require("../Animation");
const styles = {
    positionTop: (0, app_1.css) `
    bottom: 100%;
  `,
    positionLeft: (0, app_1.css) `
    top: 0;
    right: 100%;
  `,
    positionRight: (0, app_1.css) `
    top: 0;
    left: 100%;
  `,
    positionBottom: (0, app_1.css) `
    top: 100%;
    left: 0;
  `,
};
const SubMenuComponent = app_1.styled.div `
  height: 50px;
  position: relative;
  outline: none;
  background: black;
  color: white;
  &:hover {
    background: #2f2f2f;
  }
  &:focus {
    background: #2f2f2f;
  }
`;
const MenuItems = app_1.styled.div `
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  transition: opacity 500ms;
`;
const ItemComponent = app_1.styled.div `
  padding: 10px;
  height: 50px;
  max-width: 250px;
  display: flex;
  font-family: arial;
  align-items: center;
  background: black;
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
  box-sizing: border-box;
  user-select: none;
  cursor: pointer;
  &:hover {
    background: #2f2f2f;
  }
`;
const MainSection = app_1.styled.div `
  max-width: 250px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-family: arial;
  cursor: pointer;
  padding: 10px;
  box-sizing: border-box;
  user-select: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
`;
function SubMenu({ title, icon, open = false, className, onMouseEnter, onMouseLeave, onClick, onBlur, position = 'positionBottom', children, animationProps, }) {
    return ((0, jsx_runtime_1.jsxs)(SubMenuComponent, Object.assign({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onBlur: onBlur, tabIndex: 0, className: className }, { children: [(0, jsx_runtime_1.jsxs)(MainSection, Object.assign({ onClick: onClick }, { children: [title, icon] })), (0, jsx_runtime_1.jsx)(Animation_1.Animation, Object.assign({}, animationProps, { children: open && ((0, jsx_runtime_1.jsx)(MenuItems, Object.assign({ css: (0, app_1.css) `
              ${styles[position]}
            ` }, { children: children }))) })), (0, jsx_runtime_1.jsx)(MenuItems, {})] })));
}
exports.SubMenu = SubMenu;
function SubMenuItem({ children, className, onClick, }) {
    return ((0, jsx_runtime_1.jsx)(ItemComponent, Object.assign({ className: className, onClick: onClick }, { children: children })));
}
exports.SubMenuItem = SubMenuItem;
